import { render, staticRenderFns } from "./project-status-display.vue?vue&type=template&id=57536a10&"
import script from "./project-status-display.vue?vue&type=script&lang=ts&"
export * from "./project-status-display.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57536a10')) {
      api.createRecord('57536a10', component.options)
    } else {
      api.reload('57536a10', component.options)
    }
    module.hot.accept("./project-status-display.vue?vue&type=template&id=57536a10&", function () {
      api.rerender('57536a10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/projects/components/project-status-display.vue"
export default component.exports